import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useApi } from "@/lib/api";
import { PageTitle } from "@/components/Bits";
import SessionTable from "@/components/SessionTable";

export default function AdminSessions() {
  const api = useApi();
  const [params, setParams] = useSearchParams();
  const userId = params.get("user");
  const [q, setQ] = useState("");
  const [verdict, setVerdict] = useState("all");
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const p = new URLSearchParams();
    if (userId) p.set("user_id", userId);
    if (verdict !== "all") p.set("verdict", verdict);
    if (q) p.set("q", q);
    const t = setTimeout(() => api("get", `/admin/sessions?${p}`).then(setRows), 250);
    return () => clearTimeout(t);
  }, [api, q, verdict, userId]);

  return (
    <div className="fade-up" data-testid="admin-sessions-page">
      <PageTitle kicker="Super admin" title="User responses" />
      <div className="flex flex-wrap gap-3 mb-6">
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name, email, destination" className="max-w-sm bg-slate-900 border-slate-800" data-testid="admin-sessions-search" />
        <Select value={verdict} onValueChange={setVerdict}>
          <SelectTrigger className="w-44 bg-slate-900 border-slate-800" data-testid="admin-sessions-verdict-filter"><SelectValue /></SelectTrigger>
          <SelectContent className="bg-slate-900 border-slate-800">
            <SelectItem value="all">All results</SelectItem>
            <SelectItem value="PASS">Passed</SelectItem>
            <SelectItem value="FAIL">Failed</SelectItem>
          </SelectContent>
        </Select>
        {userId && <button onClick={() => setParams({})} data-testid="clear-user-filter-btn" className="text-xs font-mono text-blue-400 border border-slate-800 px-3">FILTERED BY USER · CLEAR</button>}
      </div>
      <SessionTable sessions={rows} showUser basePath="/admin/sessions" />
    </div>
  );
}
